import React, { } from 'react';
import { useTranslation } from 'localization/useTranslation';
import DescriptionCard, { DescriptionCardSkeleton } from 'components/DescriptionCard/DescriptionCard';
import { TIME_VIEW } from 'components/Time/TimeView';
import { GalleryItem } from '@patternfly/react-core';

const IothubDeviceCard = ({ iotDeviceInfo, isLoading = false }) => {
  const T = useTranslation();
  const iotDeviceModels = [
    { label: T.asset.authentication.type, path: 'iotHubDevice.authentication.type' },
    { label: T.asset.connectionStatus, path: 'iotHubDevice.connectionState' },
    { label: T.asset.connectionStatusUpdate, path: 'iotHubDevice.connectionStateUpdatedTime', time: TIME_VIEW.relative },
    { label: T.asset.lastActive, path: 'iotHubDevice.lastActivityTime', time: TIME_VIEW.relative },
    { label: T.common.primaryConnectionString, path: 'primaryConnectionString', clipboard: true },
    { label: T.common.secondaryConnectionString, path: 'secondaryConnectionString', clipboard: true }
  ];

  return (
    (iotDeviceInfo && <GalleryItem>
      { isLoading && <DescriptionCardSkeleton /> }
      { !isLoading && iotDeviceInfo &&
        <DescriptionCard
          models={iotDeviceModels}
          item={iotDeviceInfo}
          heading={T.common.iothubDevice}
          isLoading={isLoading}
        />
      }
    </GalleryItem>) || <></>
  );
};

export default IothubDeviceCard;
